import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { Header } from "../Header";
import { Footer } from "../Footer";
import { FloatingWhatsAppButton } from "../FloatingWhatsAppButton";

export function MainLayout() {
  return (
    <Box>
      <Header />
      <Outlet />
      <Footer />
      <FloatingWhatsAppButton />
    </Box>
  );
}
